import { Box, Grid, LinearProgress, Tooltip, Typography } from "@mui/material";
import { bytesConverter } from "../MemoryProgress/bytesConverter";
import { Workspaces } from "@mui/icons-material";

export interface IDashboardCardWorkspace {
    name: string;
    totalSpace: number;
    usedSpace: number;
    freeSpace: number;
}

export const DashboardCardWorkspace = ({
    name,
    totalSpace,
    usedSpace,
    freeSpace
}: IDashboardCardWorkspace) => {
    const getProgressPercentage = (used: number, total: number) => {
        return (used / total) * 100;
    };
    return (
        <Box
            sx={{
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "4px",
                opacity: 1,
            }}
            display="flex"
            flexDirection="column"
            border="1px solid #0000001A"
            borderRadius="4px"
            width="100%"
            height="93px"
        >
            <Box
                sx={{ padding: "12px" }}
                display="flex"
                flexDirection={"column"}
            >
                <Box sx={{ display: "flex", gap: "8px", paddingBottom: "12px" }}>
                    <Box
                        width="22px"
                        height="22px"
                        sx={{
                            backgroundColor: "#22638D40"
                        }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        borderRadius="2px"
                    >
                        <Workspaces
                            fontSize="small"
                            sx={{
                                color: "#22638D",
                            }}
                        />
                    </Box>
                    <Tooltip title={name}>
                        <Typography
                            sx={{
                                textAlign: "left",
                                font: "normal normal 600 16px/21px Segoe UI",
                                letterSpacing: "0px",
                                color: "#2D2D2D",
                                opacity: 1,
                                display: "inline-block",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {name}
                        </Typography>
                    </Tooltip>
                </Box>
                <Box sx={{ paddingBottom: "8px" }}>
                    <LinearProgress
                        variant="determinate"
                        value={getProgressPercentage(usedSpace, totalSpace)}
                        sx={{
                            height: '8px',
                            borderRadius: '2px',
                            flex: 1,
                            backgroundColor: "#E9EFF4",
                            "& .MuiLinearProgress-bar": {
                                backgroundColor: '#22638D',
                                borderRadius: '2px 0px 0px 2px'
                            }
                        }}
                    />
                </Box>
                <Box sx={{ margin: '0 0 12px 0' }} display={"flex"} justifyContent="space-between" alignItems="start">
                    <Typography
                        sx={{
                            font: "normal normal normal 14px/21px Segoe UI",
                            letterSpacing: "0px",
                            color: "#2D2D2D",
                            display: "inline",
                        }}
                    >
                        {bytesConverter(usedSpace)}
                    </Typography>

                    <Typography
                        sx={{
                            font: "normal normal normal 14px/21px Segoe UI",
                            letterSpacing: "0px",
                            color: "#969696",
                            display: "inline",
                        }}
                    >
                        {bytesConverter(totalSpace)}
                    </Typography>

                </Box>
            </Box>

        </Box>
    )
}